import { TemplateElement, html, defineElement, unsafeHTML } from '@webtides/element-js';
import style from './product-card.css';
import i18n from '../../utils/i18n.js';
import '../card/card.js';
import '../icon/icon.js';

/**
 * @property {string} headline
 * @property {string} text
 * @property {string[]} benefits
 * @property {object} link
 */
export default class ProductCard extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            text: '',
            benefits: [],
            link: undefined,
        };
    }

    template() {
        // TODO: copy checkmark (there are already two different ones...) icon into project.
        return html`
            <mb-card class="h-full">
                <div class="h-full flex flex-col gap-fix-l">
                    <div>
                        <h3 class="fix-title3-medium mb-fix-2xs">${unsafeHTML(this.headline)}</h3>
                        <div class="richtext fix-body2 text-green-light">${unsafeHTML(this.text)}</div>
                    </div>
                    <div class="flex-1">
                        <strong class="mb-16">${i18n('productCards.yourBenefits')}</strong>
                        <ul class="mb-0 list-disc">
                            ${this.benefits.map(
                                (benefit) => html`
                                    <li class="flex items-start gap-16 mt-16">
                                        <svg
                                            class="shrink-0"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M20 6L9 17L4 12"
                                                stroke="#144B3C"
                                                stroke-width="1.68"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        ${benefit}
                                    </li>
                                `,
                            )}
                        </ul>
                    </div>
                    <a href="${this.link?.url}" class="Button btn btn-primary w-full" element="product card"
                        >${this.link?.text}</a
                    >
                </div>
            </mb-card>
        `;
    }
}

defineElement('mb-product-card', ProductCard);
